'use client'
/**
 * The name for the extension that this package creates to
 * integrate with the Client SDK.
 */
const CLIENT_EXTENSION_NAME = 'sdk-react-core-integration';

export { CLIENT_EXTENSION_NAME };
